<div class="headerlp">
  <div class="contotpar">
    <div class="cmtp">
      <span id="mtotpar"></span><span class="icparld ui-badge ui-badge--soft-neutral ui-badge--lg"> &nbsp;<i class="fa-duotone fa-regular fa-users icparld"></i></span>
    </div>
    <div class="countselmt"></div>
    <div class="countseltxt"></div>
    <div class="actlp">
      <span class="cutrespact">Actions :</span>
      <select class="selactlp ui-select ui-select--sm">
        <option value="flag">Marquer</option>
        <option value="ban">Bloquer</option>
        <option value="compost">Composter</option>
        <option value="decompost">Décomposter</option>
        <option value="export">Exporter</option>
        <option value="export2">Exporter au gabarit Wilout</option>
        <option value="changetpl">Changer le tarif</option>
      </select>
    </div>
    <div class="btnaddPar ui-btn ui-btn--primary ui-btn--sm ui-btn--pill ui-btn--auto">
      <span class="cutresp7"><i class="far fa-check-square"></i> &nbsp; </span>Aucune sélection
    </div>
    <div class="btnExportAll ui-btn ui-btn--secondary ui-btn--sm ui-btn--auto">
      <i class="fa-duotone fa-regular fa-file-arrow-down"></i>
    </div>
  </div>
  <div class="cleanSearch"><i class="fas fa-times-circle"></i></div>
  <input type="text" placeholder="Rechercher un participant" class="searchPar" autocomplete="off" name="search visitor">
  <div class="searchiclp"><i class="fal fa-search"></i></div>
  <div class="filter-btn filter-toggle" tag='filter-toggle'>
    <i class="fa-solid fa-filter"></i>
  </div>
  <div class="filter-btn filter-notscanned" tag='filter-notscanned'>
    <i class="fa-solid fa-barcode"></i>
  </div>
  <div class="filter-btn filter-scanned" tag='filter-scanned'>
    <i class="fa-solid fa-barcode-read"></i>
  </div>
  <div class="filter-btn filter-banned" tag='filter-banned'>
    <i class="fa-solid fa-hand"></i>
  </div>
  <div class="filter-btn filter-flagged" tag='filter-flagged'>
    <i class="fa-solid fa-flag"></i>
  </div>
  <div class="filter-btn filter-nfc" tag='filter-nfc'>
    <i class="fa-solid fa-nfc-signal"></i>
  </div>
  <div class="filter-tooltip">
  </div>
</div>
<div class="bulk-tpl-panel" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.45);z-index:1000;align-items:center;justify-content:center;">
  <div style="background:var(--ui-color-surface,#fff);border-radius:12px;width:420px;max-width:90vw;padding:24px;box-shadow:0 8px 32px rgba(0,0,0,0.2);">
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;">
      <span style="font-weight:700;font-size:16px;"><i class="fa-regular fa-ticket" style="margin-right:8px;"></i>Changer le tarif</span>
      <div class="bulk-tpl-close" style="cursor:pointer;font-size:20px;opacity:0.5;line-height:1;">&times;</div>
    </div>
    <input type="text" class="input-bulk-tpl-search boc-input" placeholder="Rechercher un tarif..." style="width:100%;margin-bottom:8px;box-sizing:border-box;">
    <div class="bulk-tpl-search-list" style="max-height:240px;overflow-y:auto;border:1px solid var(--ui-color-border,#e0e0e0);border-radius:4px;"></div>
  </div>
</div>
<div class="htablp">
  <div class="htc htcf">
    <input type="checkbox" id="inallsel">
    <label class="laballsel" for="inallsel"><span class="casallsel"><i class="fas fa-check icallsel"></i></span></label>
  </div>
  <div class="htc htcdate" tag="1" id="triondown">
    Date<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htcname" tag="2" id="">
    Nom<span class="cutresp11"> / Prénom</span><span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htcmail" tag="3" id="">
    Adresse e-mail<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htctpl" tag="4" id="">
    <span class="visresp10">T</span><span class="cutresp10">Nom du t</span>arif<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htckey" tag="5" id="">
    Code-barres<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htcnfc" tag="7" id="">
    Short tag<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htcnfclong" tag="8" id="">
    Long tag<span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
  <div class="htc htccontrol" tag="6" id="">
    <span class="cutresp12">Contrôles</span><span class="ictrie">&nbsp; <i class="fas fa-chevron-down"></i></span>
  </div>
</div>
<div class="contPar">
</div>
<div class="footerlp">
  <div class="contreslp">
    Résultats :&nbsp;<span class="rpp"></span>
  </div>
  <div class="contpage">
    <span>
      <span class="cutresp3"><span class="cutresp2">Nombre d'</span>élements par page : &nbsp;</span>
      <select class="selepp ui-select ui-select--sm">
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="300">300</option>
        <option value="500">500</option>
    </select>
    </span>
    <span class="cutresp7">
    &nbsp; - &nbsp; Page : &nbsp;
    </span>
    <span class="cplparr cplparroff btnPrevLP"><i class="fas fa-arrow-alt-left"></i></span>
    <span class="cplp cplpon">1</span>
    <span class="cplp cplpoff">...</span>
    <span class="cplp"></span>
    <span class="cplparr btnNextLP"><i class="fas fa-arrow-alt-right"></i></span>
  </div>
</div>
<app-participant-detail-drawer
  [isOpen]="drawerOpen"
  [participant]="drawerParticipant"
  [availableTpls]="drawerTpls"
  (closed)="onDrawerClose()"
  (saved)="onDrawerSave($event)"
  (tplChanged)="onDrawerTplChanged($event)"
  (nfcAssociated)="onDrawerNfcAssociated($event)"
  (nfcDisassociated)="onDrawerNfcDisassociated($event)"
  (flagToggled)="onDrawerFlagToggled($event)"
  (banToggled)="onDrawerBanToggled($event)"
  (scanIncremented)="onDrawerScanIncremented($event)"
  (scanDecremented)="onDrawerScanDecremented($event)">
</app-participant-detail-drawer>

<!-- Confirmation d'export CSV (calque de la popup du BO cashless) -->
<div class="fdExportAllConfirm"></div>
<div class="blocExportAllConfirm">
  <div class="headExportAllConfirm">
    <span class="titheadExportAllConfirm"><i class="fa-duotone fa-regular fa-file-arrow-down"></i> &nbsp; Export CSV</span>
    <span class="closeExportAllConfirm"><i class="fas fa-times"></i></span>
  </div>
  <div class="bodExportAllConfirm">
    <div class="textExportAllConfirm">
      Exporter les participants au format CSV ?
    </div>
    <div class="wrapBtnsExportAllConfirm">
      <div class="btnConfirmExportAll ui-btn ui-btn--primary ui-btn--auto">
        <i class="fas fa-check"></i> &nbsp;Confirmer
      </div>
    </div>
  </div>
</div>
